import { observable } from 'mobx';

export type StationResponseArgs = {
  id: number;
  station_name: string;
  prefecture_name: string;
  prefecture_id?: number;
  post: string;
  add: string;
  lon: number;
  lat: number;
};

export type StationArgs = {
  id: number;
  stationName: string;
  prefectureName: string;
  prefectureId?: number;
  post: string;
  add: string;
  lon: number;
  lat: number;
};

export const convertStationResponseToArgs = (response: StationResponseArgs): StationArgs => {
  return {
    id: response.id,
    stationName: response.station_name,
    prefectureName: response.prefecture_name,
    prefectureId: response.prefecture_id,
    post: response.post,
    add: response.add,
    lon: response.lon,
    lat: response.lat
  };
};

export default class Station {
  @observable id: number;
  @observable stationName: string;
  @observable prefectureName: string;
  @observable prefectureId?: number;
  @observable post: string;
  @observable add: string;
  @observable lon: number;
  @observable lat: number;

  constructor(args: StationArgs) {
    this.id = args.id;
    this.stationName = args.stationName;
    this.prefectureName = args.prefectureName;
    this.prefectureId = args.prefectureId;
    this.post = args.post;
    this.add = args.add;
    this.lon = args.lon;
    this.lat = args.lat;
  }

  get submitParams() {
    return {
      station_name: this.stationName,
      prefecture_id: this.prefectureId,
      post: this.post,
      add: this.add,
      lon: this.lon,
      lat: this.lat
    };
  }
}
